module.exports = __webpack_public_path__ + "img/check.d563c440.svg";